import { render, staticRenderFns } from "./Trade.vue?vue&type=template&id=38f5d17b&scoped=true"
import script from "./Trade.vue?vue&type=script&lang=js"
export * from "./Trade.vue?vue&type=script&lang=js"
import style0 from "./Trade.vue?vue&type=style&index=0&id=38f5d17b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f5d17b",
  null
  
)

export default component.exports